<template>
  <div>
    <Categories
      v-if="hasPermission('automaticSentences.categories.view')"
      class="mb-2"
    />
    <Sentences v-if="hasPermission('automaticSentences.sentences.view')" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Categories from '@/views/admin/management/automaticSentence/Categories';
import Sentences from '@/views/admin/management/automaticSentence/Sentences';

export default {
    components: {
        Sentences,
        Categories,
    },
    computed: {
        ...mapGetters([
            'hasPermission',
        ]),
    },
};
</script>
